/* Cabal · encabezado compacto en móvil: guarda el buscador al hacer scroll. */
(function () {
  var header = document.querySelector('.cs-header[data-cs-sticky]');
  if (!header) return;
  var pending = false;

  function apply() {
    pending = false;
    if (window.innerWidth > 749) {
      header.classList.remove('is-compact', 'is-search-open');
      return;
    }
    var compact = (window.scrollY || window.pageYOffset || 0) > 150;
    if (compact === header.classList.contains('is-compact')) return;
    header.classList.toggle('is-compact', compact);
    if (!compact) header.classList.remove('is-search-open');
  }

  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(apply); }
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cs-search-toggle]')) return;
    e.preventDefault();
    header.classList.toggle('is-search-open');
    if (header.classList.contains('is-search-open')) {
      var input = header.querySelector('.cs-search input[type=search]');
      if (input) input.focus();
    }
  });

  apply();
})();